import { useEffect, useState } from 'preact/hooks'

export function useHasScroll() {
  const [hasScroll, setHasScroll] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setHasScroll(window.scrollY > 0)
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return hasScroll
}
